import { useState } from "react";
import { Link } from "react-router-dom";
import { API, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/pages/Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await API.post("/auth/forgot-password", { email });
      setMessage(data.message);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Mot de passe oublié" subtitle="Recevez un lien de réinitialisation">
      {message ? (
        <div className="space-y-4">
          <p className="rounded-md bg-emerald-50 px-3 py-2 text-sm text-emerald-700" data-testid="forgot-success">{message}</p>
          <Link to="/login" className="block text-center text-sm font-medium text-blue-600 hover:underline" data-testid="link-back-login">
            Retour à la connexion
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {error && <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="forgot-error">{error}</p>}
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="mt-1" />
          </div>
          <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-button">
            {loading ? "Envoi..." : "Envoyer le lien"}
          </Button>
          <p className="text-center text-sm text-slate-500">
            <Link to="/login" className="font-medium text-blue-600 hover:underline">Retour à la connexion</Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
}
